export function getCurrencySymbol(currencyCode) {
  return (0)
    .toLocaleString(undefined, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    .replace(/[0.,]/g, '');
}

const safeInt = (amount, precision = 0) => Math.round(`${parseFloat(amount)}e${precision}`);

export const getCurrencyDecimals = currency =>
  Intl.NumberFormat(undefined, { currency, style: 'currency' }).resolvedOptions().maximumFractionDigits ?? 0;

export const toMinorUnits = (currency, major) => safeInt(major, getCurrencyDecimals(currency));

export const toMajorUnits = (currency, minor) => safeInt(minor) / 10 ** getCurrencyDecimals(currency);
